import React from 'react';
import audioBack from '../../assets/audio/TT VE2023 SFX.mp3';


export default class AudioComponent extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {pageKey:props.pageKey, speaker:props.speaker };
	}



	componentDidUpdate() {
		if (this.state.pageKey !== this.props.pageKey) {
			this.setState({pageKey:this.props.pageKey});
		}
		if (this.state.speaker !== this.props.speaker) {
			this.setState({speaker:this.props.speaker}, () => {
				const audioBack = document.getElementById("audioBack");
				if (!audioBack) return;
				if (!this.state.speaker) audioBack.pause();
				else audioBack.play();
			});
		}
	}

	render() {
		const {pageKey} = this.state;
		return (

			<div id="aud_div">
				<audio loop={true} id='audioBack' >
					<source src={audioBack} ></source>
				</audio>

			</div>

		);
	}
}

